/**
 * ListSelection 스타일
 * @description 표시(mark)는 고르지 않았을 때도 **자리를 남긴다.** 빼버리면 선택이 바뀔 때마다
 *   24 + 갭 12 만큼 행 폭이 출렁인다. rest 는 배경이 없다 — 담는 화면이 그대로 비친다.
 */
import { cva } from "class-variance-authority";

export const listSelectionStyles = {
  root: cva(
    [
      "flex w-full cursor-pointer items-center justify-between",
      "gap-[var(--fw-space-gap-md)] p-[var(--fw-space-inset-sm)]",
      "rounded-[var(--fw-radius-md)] text-left transition-colors",
      "focus-visible:outline-2 focus-visible:outline-offset-2",
      "focus-visible:outline-[var(--fw-color-border-focused)]",
    ],
    {
      variants: {
        selected: {
          true: "bg-[var(--fw-color-surface-brand-transparent-pressed)]",
          false: "hover:bg-[var(--fw-color-surface-brand-transparent-hovered)]",
        },
      },
    },
  ),
  title: "fw-l1 truncate text-[var(--fw-color-content-neutral-primary)]",
  mark: cva(
    "size-[var(--fw-size-control-xs)] shrink-0 rounded-[var(--fw-radius-full)]",
    {
      variants: {
        selected: {
          true: "bg-[var(--fw-color-content-brand-primary)]",
          false:
            "shadow-[inset_0_0_0_var(--fw-border-lg)_var(--fw-color-surface-neutral-tertiary)]",
        },
      },
    },
  ),
};
